import React from "react";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../api/ApiSettings";

const initialState = {
    couriers: [],
}
export const getCouriers = createAsyncThunk('couriers', async()=>{
    const response = await fetch(`${API_URL}couriers`, null)
    const data = await response.json(); 
    return data;
})


export const couriersSlice = createSlice({
    name: 'couriers',
    initialState,
    reducers:{ 
        couriersChoice: (state,action)=>{
            state.couriers = action.payload;
        }},
    
  extraReducers: {
   
    [getCouriers.fulfilled]: (state, action) => {
      state.couriers = action.payload;
    },
   
  },
});

export const {couriersChoice} = couriersSlice.actions;
export default couriersSlice.reducer;